export default __webpack_public_path__ + "static/media/Mockito.81aa69ae.png";